import * as React from "react";
import type { SVGProps } from "react";
const SvgWatch02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={2}
      d="m16.208 18.444-.932 2.796a.53.53 0 0 1-.499.36H9.223a.53.53 0 0 1-.5-.36l-.931-2.796m0-12.888.932-2.796a.53.53 0 0 1 .499-.36h5.554c.227 0 .428.145.5.36l.931 2.796M7.266 18.444h9.468c.872 0 1.578-.707 1.578-1.578V7.397c0-.871-.706-1.578-1.578-1.578H7.266c-.872 0-1.578.707-1.578 1.578v9.469c0 .871.706 1.578 1.578 1.578Z"
    />
  </svg>
);
export default SvgWatch02;
